import React from "react";
import { Button, Segment } from "semantic-ui-react";
import { TableWithPagination } from "../../../components/TableView/TableWithPagination";
import { RoomGroupModal } from "./RoomGroupModal";
import { LOADING } from "../../../utils/helpers/phases";

export class RoomGroupsList extends React.Component {
  render() {
    const { props } = this;

    const headers = [
      {
        label: props.t("room:nameText"),
        key: "name"
      }
    ];
    return (
      <Segment
        basic
        loading={
          props.roomsPhase === LOADING || props.roomGroupsPhase === LOADING
        }>
        {props.isAdmin && !props.isKWHotelUser ? (
          <React.Fragment>
            <RoomGroupModal initialValues={{ ...props.selected }} {...props} />
            <Button color="orange" onClick={() => props.toggleModal()}>
              {props.t("room:addRoomGroupButton")}
            </Button>
          </React.Fragment>
        ) : (
          undefined
        )}
        {props.isAdmin &&
          props.isKWHotelUser && (
            <Button color="orange" onClick={props.syncRoomGroupsAndRooms}>
              {props.t("synchronization:synchronizeButton")}
            </Button>
          )}
        <TableWithPagination
          headers={headers}
          data={props.roomGroups}
          handleRemoveClick={({ roomGroupId }) =>
            props.removeRoomGroup(roomGroupId)
          }
          handleEditClick={roomGroup => props.toggleModal(roomGroup)}
          showActionButtons={props.isAdmin && !props.isKWHotelUser}
        />
      </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/rooms/groups/RoomGroupsList/RoomGroupsList.js